import React, {FC, ReactNode, useState} from 'react';
import styled from 'styled-components';

import {Icon, IconName} from '../../../../libs/shared/ui/src/components/icon/icon';
import {useUserTheme} from '../../../../libs/shared/ui/src/theme/userThemeProvider';
import {openInBrowser} from '../../../../srcCommon/browser/openInBrowser';
import {WorkspaceGenericItem} from '../../../components/inboxes/workspaces/workspaceGenericItem';
import {StyledFlex} from '../reportViewer/reportCommons';

/*
 * Styles.
 */

const StyledIcon = styled(Icon)`
  margin-left: 4px;
`;

/*
 * Props.
 */

interface ReportNavigationHelpLinkProps {
  linkUrl: string;
  iconName: IconName;
  name: ReactNode;
  interactionProps?: {'data-testid'?: string};
}

/*
 * Component.
 */

export const ReportNavigationHelpLink: FC<ReportNavigationHelpLinkProps> = ({
  linkUrl,
  iconName,
  name,
  interactionProps,
}) => {
  const theme = useUserTheme();
  const [shouldShowExternalLinkIcon, setShouldShowExternalLinkIcon] = useState(false);

  return (
    <div
      onMouseEnter={() => setShouldShowExternalLinkIcon(true)}
      onMouseLeave={() => setShouldShowExternalLinkIcon(false)}
    >
      <WorkspaceGenericItem
        iconName={iconName}
        onClick={() => openInBrowser(linkUrl)}
        shouldAlphabetizeWorkspace={false}
        workspaceDragItem={undefined}
      >
        <StyledFlex {...interactionProps}>
          {name}
          {shouldShowExternalLinkIcon && <StyledIcon name="externalLinkSmall" color={theme.greys.shade70} />}
        </StyledFlex>
      </WorkspaceGenericItem>
    </div>
  );
};
